module.exports = __webpack_public_path__ + "static/media/kakao.e5399fc8.svg";